import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationService } from '@cbuild/core';

function adjustToTimeZone(value: string, offset: number): number {
  const date = new Date(value);
  return date.getTime() + offset + date.getTimezoneOffset() * 60000;
}

@Pipe({
  name: 'fromUTC'
})
export class FromUTCPipe implements PipeTransform {
  private timeOffset: number;
  private timeZone: string;
  private datePipe: DatePipe;

  constructor(applicationService: ApplicationService) {
    this.datePipe = new DatePipe(applicationService.locale);
    this.timeOffset = applicationService.basicInfo!.timeOffset || 0;
    this.timeZone = applicationService.basicInfo!.timeZoneCode || '';
  }

  public transform(
    value: string | number | Date | null | undefined,
    type = 'short',
    timezone = 'include'
  ): string {
    if (!value) {
      return '';
    }

    const input =
      typeof value === 'string' || typeof value === 'number'
        ? new Date(value)
        : value;
    if (!(input instanceof Date) || isNaN(input.getTime())) return '';

    const timestamp = this.timeOffset
      ? adjustToTimeZone(input.toISOString(), this.timeOffset)
      : input.getTime();

    const returnValue = this.datePipe.transform(timestamp, type) || '';

    return this.timeZone && timezone === 'include'
      ? `${returnValue} (${this.timeZone})`
      : returnValue;
  }
}
